/** Soft hero-glow behind content. Default: full-page colour in the corners.
 *  `subtle` (dashboards/workspaces): faint colour in the corners only, page stays white. */
export default function PageGlow({ subtle = false }) {
  if (subtle) {
    return (
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-1/2 -translate-x-1/2 w-screen -z-10 overflow-hidden">
        <div className="liquid-blob blob-a opacity-25" style={{ background: "#BFDBFE", position: "absolute", width: "28vw", height: "28vw", top: "-16vw", left: "-9vw" }} />
        <div className="liquid-blob blob-b opacity-25" style={{ background: "#FDE68A", position: "absolute", width: "24vw", height: "24vw", top: "-13vw", right: "-9vw" }} />
        <div className="liquid-blob blob-c opacity-15" style={{ background: "#DBEAFE", position: "absolute", width: "22vw", height: "22vw", bottom: "-14vw", right: "8vw" }} />
      </div>
    );
  }
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-1/2 -translate-x-1/2 w-screen -z-10 overflow-hidden">
      <div className="liquid-blob blob-a opacity-70" style={{ background: "#BFDBFE", position: "absolute", width: "46vw", height: "46vw", top: "-14vw", left: "-10vw" }} />
      <div className="liquid-blob blob-b opacity-70" style={{ background: "#FDE68A", position: "absolute", width: "40vw", height: "40vw", top: "-8vw", right: "-10vw" }} />
      <div className="liquid-blob blob-c opacity-50" style={{ background: "#DBEAFE", position: "absolute", width: "38vw", height: "38vw", bottom: "-16vw", right: "8vw" }} />
      <div className="liquid-blob blob-b opacity-40" style={{ background: "#FEF3C7", position: "absolute", width: "30vw", height: "30vw", bottom: "-10vw", left: "-6vw", animationDelay: "-7s" }} />
    </div>
  );
}
